import { useState } from 'react';
import { css } from '@emotion/react';
import { Grid } from '@material-ui/core';
import { colors } from '@/styles';
import { useClientUser } from '@/hooks';
import { OnwardCardTab, OnwardCardTabContainer } from '@/components/Tabs';
import SKUs from '../SKUs';
import ServiceCatalog from '../ServiceCatalog';

const TABS = [
    { label: "SKU's", value: 0 },
    { label: 'Services', value: 1 },
];

const SKUsAndServices = ({ clientRef }) => {
    const { accountType } = useClientUser();
    // Service catalogs are shipper-owned, so the Services sub-tab only renders on shipper
    // profiles for now. A read-only carrier-side view comes with the profile-pages revamp.
    const showServices = accountType === 'shipper';
    const tabs = showServices ? TABS : TABS.filter((t) => t.value === 0);
    const [tab, setTab] = useState(0);
    const activeTab = showServices ? tab : 0;

    return (
        <div>
            <OnwardCardTabContainer
                textColor="primary"
                indicatorColor="primary"
                value={activeTab}
                onChange={(_, next) => setTab(next)}
            >
                {tabs.map((t) => (
                    <OnwardCardTab key={`sku-services-tab-${t.value}`} {...t} />
                ))}
            </OnwardCardTabContainer>
            <Grid
                container
                css={css`
                    background-color: white;
                    border: 1px solid ${colors.greys.border};
                    width: 100%;
                    padding: 1rem 2rem;
                    border-top-left-radius: 0;
                `}
            >
                {activeTab === 0 && <SKUs clientRef={clientRef} />}
                {activeTab === 1 && <ServiceCatalog clientRef={clientRef} />}
            </Grid>
        </div>
    );
};

export default SKUsAndServices;
